module.exports = __webpack_public_path__ + "img/preprocessing-data.8936ddd0.png";